/**
 * 安全解码，避免 URL 中非法编码导致 URIError
 * @param {string} str
 * @returns {string}
 */
function safeDecodeURIComponent(str) {
  try {
    return decodeURIComponent((str || '').replace(/\+/g, ' '));
  } catch (e) {
    return str || '';
  }
}

/**
 * 获取query参数对象
 */
export default () => {
  const search = window.location.href.split('?')[1];
  if (!search) {
    return {};
  }

  return search.split('&').reduce((prev, curr) => {
    const p = curr.split('=');
    // eslint-disable-next-line no-param-reassign
    prev[safeDecodeURIComponent(p[0])] = safeDecodeURIComponent(p[1] || '');
    return prev;
  }, {});
};
